import $ from "jquery";

/*
 * Language Data Service -
 * Wrapper for language dropdown select ajax calls
 */
function executeCall(method, url, payload) {
        var executionPromise = new Promise(
        function (resolve, reject) {
            $.ajax({
                type: method,
                url: url,
                data: payload,
                dataType: 'json',
                contentType: 'application/x-www-form-urlencoded; charset=utf-8',
                success: function (data) {
                    return resolve(data);
                },
                error: function (jqXhr, textStatus, errorThrown) {
                    var data = JSON.parse(jqXhr.responseText);
                    return reject(data);
                }
            });
        }
    );

    return executionPromise;
}

class LanguageDataService {
    constructor() {
    }

    init() {
    }

    // Public Methods
    changeLanguage(localeCode) {
        return executeCall("POST", "/language", { localeCode: localeCode });
    }
}

const languageDataService = new LanguageDataService();
export default languageDataService;